// extracted by mini-css-extract-plugin
export default {"editForm":"NumberSetup_editForm__c+pxk","formGroup":"NumberSetup_formGroup__6zjrG","submitButton":"NumberSetup_submitButton__KuveK"};